module.exports = __webpack_public_path__ + "static/creating-the-twentieth-century-d788aa66b89f95bd13d517a262212d46.jpg";